var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormProvider',{attrs:{"form":_vm.form}},[_c('FormLayout',{attrs:{"labelCol":0,"wrapperCol":0,"labelWidth":120}},[_c('SchemaField',{attrs:{"schema":_vm.operateFormSchema || {}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }